import React from 'react';
import { CATEGORIES, rand } from './financeApi';

const LABELS = { month: 'This month', quarter: 'This quarter', six_months: 'Last 6 months', year: 'This year', last_year: 'Past year' };

export const ReportsPanel = ({ reports }) => {
  if (!reports) return null;
  const max = Math.max(1, ...reports.monthly.map((m) => m.total));
  return (
    <section className="space-y-4" data-testid="finance-reports">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        {Object.entries(reports.periods).map(([key, p]) => (
          <div key={key} className={`rounded-2xl border p-4 bg-white ${key === 'month' ? 'border-emerald-300 ring-1 ring-emerald-200' : ''}`} data-testid={`report-${key}`}>
            <p className="text-xs uppercase tracking-wide text-muted-foreground">{LABELS[key]}</p>
            <p className="text-xl sm:text-2xl font-heading font-bold mt-1" data-testid={`report-${key}-total`}>{rand(p.total)}</p>
            <p className="text-xs text-muted-foreground">{p.count} expense(s)</p>
            <div className="mt-2 space-y-0.5">
              {CATEGORIES.map((c) => p.by_category[c.value] > 0 && (
                <p key={c.value} className="text-xs flex justify-between"><span>{c.label}</span><span className="font-medium">{rand(p.by_category[c.value])}</span></p>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="rounded-2xl border bg-white p-4">
        <p className="text-sm font-semibold mb-3">Spending per month (last 12 months)</p>
        <div className="flex items-end gap-1 sm:gap-2 h-36" data-testid="report-monthly-chart">
          {reports.monthly.map((m) => (
            <div key={m.month} className="flex-1 flex flex-col items-center justify-end h-full">
              <span className="text-[10px] text-muted-foreground whitespace-nowrap">{m.total ? `R${Math.round(m.total)}` : ''}</span>
              <div className="w-full rounded-t-md bg-emerald-500/80 transition-[height] duration-500" style={{ height: `${(m.total / max) * 100}%`, minHeight: m.total ? 4 : 1 }} />
              <span className="text-[10px] text-muted-foreground mt-1">{m.label.slice(0, 3)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
